import {
  nextTick, onBeforeUnmount, onMounted, ref, toRefs,
} from 'vue';
import { track } from '../tracking/trackingLayer';
import EventBus from '../../scripts/lib/EventBus.js';

const templateElement = document.getElementById('add-to-cart-button-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    syan: {
      type: Number,
      required: true,
    },
    artikel: {
      type: Object,
      required: true,
    },
    artikelNr: {
      type: String,
      required: true,
    },
    isInitialArticle: {
      type: Boolean,
      required: true,
    },
    dimension: {
      type: String,
      required: true,
    },
    isVspEnabled: {
      type: Boolean,
      required: false,
    },
  },

  setup(props) {
    const {
      isInitialArticle,
      artikelNr,
    } = toRefs(props);
    const warenkorbbutton = ref(null);

    function addToCart() {
      if (isInitialArticle.value) {
        EventBus.emit(
          'bewerten:vue:dimension:select',
          {
            dimension: props.dimension,
            add2CartAfterSizeSelection: true,
          },
        );
        EventBus.on('bewerten:vue:layer:hide', () => {
          nextTick(() => {
            if (props.artikel.outOfStock) {
              return;
            }
            emitCartContent();
          });
        });
        sendTrackingInfo(['click', 'cart_sizelayer']);
      } else if (artikelNr.value) {
        emitCartContent();
      }
    }

    function getA2CPayload() {
      const payload = {
        detail: {
          artikel: getVerkaufId(),
          menge: 1,
        },
      };
      const vertriebsinfoId = getVertriebsinfoId();
      if (vertriebsinfoId) {
        payload.detail.vertriebsinfoId = vertriebsinfoId;
      }
      return payload;
    }

    // this method is used for mocking in unit tests
    function getVerkaufId() {
      return props.artikel.verkaufId;
    }

    // this method is used for mocking in unit tests
    function getVertriebsinfoId() {
      return props.artikel.vertriebsinfoId;
    }

    function emitCartContent() {
      // see: https://brix.dev.breuni.de/kaufen/sandbox/ssi.html
      const payload = getA2CPayload();
      const customKaufCartAddEvent = new CustomEvent('kaufen:cart:add', payload);
      document.dispatchEvent(customKaufCartAddEvent);
      console.info('Artikel wurde an den Warenkorb übergeben:', payload);
      warenkorbbutton.value.setAttribute('data-test-bewerten-warenkorbbutton-payload-emitted', JSON.stringify(payload));
      window.performance.mark('bewe.pds.warenkorbbutton.payload-emitted');
    }

    function sendTrackingInfo(eventValues) {
      track({
        event_level1: 'ents',
        event_level2: null,
        event_level3: null,
        event_level4: null,
        event_level5: null,
        event: 'event.generic',
        event_values: eventValues,
      });
    }

    function a2cClick() {
      if (props.artikel.outOfStock) {
        handleOutOfStockVariant();
      } else {
        addToCart();
      }
    }

    function getVspPayload() {
      return {
        syan: props.syan,
        ...(props.artikel.colors?.aktiv?.farbId ? {farbId: props.artikel.colors.aktiv.farbId} : {}),
        listName: 'pds_cta',
      };
    }

    function vspClick() {
      const payload = getVspPayload();
      document.dispatchEvent(new CustomEvent('suchen:vsp:alternativeprodukte', {detail: payload}));
      console.info('Visuell ähnliche Produkte werden angezeigt:', payload);
      warenkorbbutton.value.setAttribute('data-test-ents-vsp-cta-payload-emitted', JSON.stringify(payload));
    }

    function handleOutOfStockVariant() {
      if (isInitialArticle.value) {
        EventBus.emit('bewerten:vue:dimension:select', { dimension: props.dimension });
      } else {
        EventBus.emit('bewerten:out-of-stock-layer:show', getVertriebsinfoId());
      }
    }

    async function addToCartFromEvent(e) {
      // This has to be awaited to ensure that vertriebsInfoId is set
      await EventBus.emit('bewerten:vue:artikel:changed', e.detail.articleId);
      emitCartContent();
    }

    onMounted(() => {
      document.addEventListener('ents:article:addtocart', addToCartFromEvent);
    });

    onBeforeUnmount(() => {
      document.addEventListener('ents:article:addtocart', addToCartFromEvent);
    });

    return {
      a2cClick,
      vspClick,
      warenkorbbutton,
    };
  },
};
